import React from 'react'

import {
    ListRadioGroup,
} from '../../business-components/RadioGroup/RadioGroup'

export const CenarioRadioGroup = props => {
    return (
        <ListRadioGroup
            list={props.values.cenarios}
            {...props}
        />
    )
}